"use strict";

class SSConfigService {
    constructor($localStorage) {
        const self = this;

        self.$localStorage = $localStorage;

        self.defAppService = {};
        if (self.$localStorage.def_app_service) {
            self.defAppService = self.$localStorage.def_app_service;
        }

        self.serverConfig = self.defAppService.serverConfig;
        if (!self.serverConfig) {
            self.serverConfig = {};
        }

        // TEMP
        self.serverConfig = SHOWSUITE.data.config;
        self.SINGAPORE_COUNTRY_CODE = 702;
    }

    // Base
    searchArrayE(array, id) {
        const self = this;

        if (!array || !id == null) return "";

        if (typeof array == "string") {
            array = self.serverConfig[array];
        }
        let object = null;
        jQuery.each(array, function(i, e) {
            if (e.id == id) {
                object = e;
            }
        });

        return object;
    }

    searchArray(array, id) {
        const self = this;

        let object = self.searchArrayE(array, id);

        return object ? object.name : "";
    }

    // General

    getCountries() {
        const self = this;

        return self.serverConfig.countries;
    }

    getCountry(country_code) {
        const self = this;

        let country = null;
        jQuery.each(self.getCountries(), function(i, e) {
            if (e.country_code == country_code) {
                country = e;
            }
        });

        return country;
    }

    getCountryName(country_code) {
        const self = this;

        let country = self.getCountry(country_code);

        return country ? country.name : "";
    }

    getRegions(country_code) {
        const self = this;

        let country = null;
        jQuery.each(self.getCountries(), function(i, e) {
            if (e.country_code == country_code) {
                country = e;
            }
        });

        return country ? country.regions : [];
    }

    getNationalities() {
        const self = this;

        return self.serverConfig.nationalities;
    }

    getNationalityName(country_code) {
        const self = this;

        let country = self.getCountry(country_code);

        return country ? country.citizenship : "";
    }

    getGenders(ec_filtered = false) {
        const self = this;

        let genders = null;

        if (ec_filtered) {
            genders = self.serverConfig.genders_ec;
        } else {
            genders = self.serverConfig.genders;
            for (var x in genders)
                genders[x].name == "Undisclosed"
                    ? genders.push(genders.splice(x, 1)[0])
                    : 0;
        }

        return genders;
    }
    getExtMappingKeys() {
        const self = this;

        return self.serverConfig.ext_mapping_keys;
    }
    getExtMappingKeyValue(key) {
        const self = this;
        return self.serverConfig.ext_mapping_keys[key];
    }

    getGenderName(id, ec_filtered = false) {
        const self = this;

        return self.searchArray(self.getGenders(ec_filtered), id);
    }

    getEducationLevels() {
        const self = this;
        return self.serverConfig.education_levels;
    }
    getEducationLevelName(id) {
        const self = this;
        return self.searchArray(self.getEducationLevels(), id);
    }
    getEmploymentStatuses() {
        const self = this;
        return self.serverConfig.employment_statuses;
    }
    getEmploymentStatusName(id) {
        const self = this;
        return self.searchArray(self.getEmploymentStatuses(), id);
    }

    getBanks(countryCode) {
        const self = this;

        let banks = self.serverConfig.banks;
        if(!countryCode) countryCode = self.SINGAPORE_COUNTRY_CODE; // Default is singapore

        if(countryCode){
            let _banks = [];
            banks.forEach(bank => {
                if(bank.name == 'OTHERS') bank.country = countryCode;
                // Fetch only those banks which has given 'countryCode'
                if(bank.country.indexOf(countryCode) != -1){
                    _banks.push(bank);
                }
            });
            if(!_banks.find(x => x.name == 'OTHERS'))
                _banks.push({id: 9999, code: 'OTHERS', name: 'OTHERS'});
            
            banks = _banks;
        }

        return banks;
    }

    getPropertyAccountTypes() {
        const self = this;

        return self.serverConfig.property_account_types;
    }

    getMrts() {
        const self = this;

        return self.serverConfig.mrt_stations;
    }

    getSchools() {
        const self = this;

        return self.serverConfig.schools;
    }

    // Property

    /**
     * @deprecated
     * @param code
     * @returns {*}
     */
    getPropertyStatuses() {
        return this.serverConfig.property_statuses;
    }

    getPropertyStatusText(code) {
        return this.searchArray("property_statuses", code);
    }

    getPropertyStatusName(code) {
        return this.searchArray("property_statuses", code);
    }

    getPropertyCategoryName(code) {
        return this.searchArray("property_categories", code);
    }

    getPropertyTypeName(code) {
        return this.searchArray("property_types", code);
    }

    getPropertyProductName(code) {
        return this.searchArray("property_products", code);
    }

    // Unit

    getUnitStatusName(code) {
        return this.searchArray("unit_statuses", code);
    }

    getUnitCategoryName(code) {
        return this.searchArray("unit_categories", code);
    }

    getUnitTypeName(code) {
        return this.searchArray("unit_types", code);
    }

    getUnitPriceTypeName(code) {
        return this.searchArray("unit_price_types", code);
    }

    getUnitKitchenTypeName(code) {
        return this.searchArray("unit_kitchen", code);
    }

    getUnitFlooringTypeName(code) {
        return this.searchArray("unit_flooring", code);
    }

    getUnitTilesTypeName(code) {
        return this.searchArray("unit_tiles", code);
    }

    // Notification

    getNotificationGroupName(code) {
        return this.searchArray("notification_groups", code);
    }

    getNotificationTypeName(code) {
        return this.searchArray("notification_types", code);
    }

    getBuyerRelationships(ec_filtered = false) {
        const self = this;

        if (ec_filtered) return self.serverConfig.relationships_ec;
        else return self.serverConfig.relationships;
    }
    getBuyerRelationshipName(code, ec_filtered = false) {
        const self = this;

        return self.searchArray(self.getBuyerRelationships(ec_filtered), code);
    }

    getRaces(ec_filtered = false) {
        const self = this;

        if (ec_filtered) return self.serverConfig.races_ec;
        return self.serverConfig.races;
    }

    getRaceName(code, ec_filtered = false) {
        const self = this;

        return self.searchArray(self.getRaces(ec_filtered), code);
    }

    // =====================================================================================
    // WEB-4518 — Master-list "main name + aliases" resolution
    //
    // Third parties spell master-list values differently from us: SingPass MyInfo sends
    // "VIETNAM" for our "Viet Nam", "SINGAPORE CITIZEN" for "Singaporean", "OTHERS" for
    // "Other". Each /config master-list row keeps its ONE main name — what every dropdown
    // shows and what gets saved — and carries its other known spellings in `aliases`
    // (countries also `citizenship_aliases`, exposed on the nationalities rows).
    //
    // The helpers below match an incoming value against the main name(s) or any alias and
    // return the EXISTING entry, so callers bind/save that entry's id or main name and never
    // the incoming text. They mirror MasterListAliasService on the API: a new spelling is a
    // new alias in the server config, with no client change.
    // =====================================================================================

    /**
     * WEB-4518 Normalise a master-list value for comparison: trim, collapse inner whitespace,
     * upper-case — so "Viet Nam", " viet   nam " and "VIET NAM" are one key.
     *
     * @param {*} value
     * @returns {string} Empty string for null/undefined.
     */
    normaliseMasterListValue(value) {
        if (value === null || value === undefined) return "";

        return String(value).replace(/\s+/g, " ").trim().toUpperCase();
    }

    /**
     * WEB-4518 Looser key with every non-alphanumeric character removed, used as the last
     * matching pass so "VIET-NAM", "VIETNAM" and "VIET NAM" meet. ASCII letters/digits only,
     * so accented names still want an explicit alias (same rule as the API).
     *
     * @param {*} value
     * @returns {string}
     */
    compactMasterListValue(value) {
        return this.normaliseMasterListValue(value).replace(/[^A-Z0-9]/g, "");
    }

    /**
     * WEB-4518 True when a resolved entry is the catch-all "Other" / "Others" row.
     *
     * @param {{name: string}|null} match A resolveMasterListEntry() result.
     * @returns {boolean}
     */
    isOtherMasterListEntry(match) {
        const name = match ? this.normaliseMasterListValue(match.name) : "";

        return name === "OTHER" || name === "OTHERS";
    }

    /**
     * WEB-4518 The rows of a master list in one uniform shape, whatever list they come from.
     *
     * Accepts a /config list key ("countries", "nationalities", "races", "races_ec") or an
     * already-loaded array of rows (e.g. SSEoiService.races, which may be the EC variant).
     *  - id:      what the Web binds/saves — `country_code` for countries, `id` otherwise
     *  - names:   the main name plus, for countries, `full_name`
     *  - aliases: other spellings from the server config (missing key -> [])
     *  - code:    ISO 3166-1 alpha-2 when the row has one (`code` / `iso_3166_2`)
     *
     * @param {string|Array} list
     * @returns {Array<{id: *, name: string, names: string[], aliases: string[], code: (string|null), row: Object}>}
     */
    getMasterListEntries(list) {
        const self = this;

        let rows = list;
        if (typeof list === "string") {
            rows = self.serverConfig ? self.serverConfig[list] : null;
        }
        if (!Array.isArray(rows)) return [];

        const clean = function (values) {
            const out = [];
            (values || []).forEach(function (v) {
                if (v === null || v === undefined) return;
                const s = String(v).trim();
                if (s !== "" && out.indexOf(s) === -1) out.push(s);
            });
            return out;
        };

        const entries = [];
        rows.forEach(function (row) {
            if (!row || typeof row !== "object") return;

            const name = (row.name === null || row.name === undefined) ? "" : String(row.name);
            entries.push({
                id: row.country_code !== undefined ? row.country_code : row.id,
                name: name,
                names: clean([name, row.full_name]),
                aliases: clean(Array.isArray(row.aliases) ? row.aliases : []),
                code: row.code || row.iso_3166_2 || null,
                row: row
            });
        });

        return entries;
    }

    /**
     * WEB-4518 Resolve a third-party spelling to the EXISTING master-list entry.
     *
     * Matching order (every pass case- and whitespace-insensitive):
     *  0. `options.code` against the entry's ISO code (MyInfo always sends one) — exact, cheapest
     *  1. the entry's main name(s) (countries: `name` and `full_name`)
     *  2. any alias
     *  3. the compact form of 1 and 2 (punctuation and spaces removed)
     *  4. nationalities only: passes 1–3 against the countries list, since MyInfo and import
     *     sheets put the country ("MYANMAR") where we expect the citizenship ("Burmese") and
     *     both key on the numeric country code
     *
     * An unmatched value is logged (console.warn, tagged WEB-4518) so the spelling can be
     * added as an alias in the server config; pass `options.log = false` where free text is
     * expected (a user-typed "Other" race).
     *
     * @param {string|Array} list A /config list key or an array of rows (see getMasterListEntries()).
     * @param {*} value The incoming spelling, e.g. "VIETNAM". May be empty when `options.code` is given.
     * @param {{code?: string, listKey?: string, log?: boolean, context?: Object}} [options]
     *        listKey: the semantic list when `list` is an array ("nationalities" enables pass 4).
     * @returns {{list: (string|null), id: *, name: string, matched_on: string, input: *, row: Object}|null}
     *          `id` is what the Web saves (numeric country code / race id), `name` the main name,
     *          `matched_on` one of "code" | "name" | "alias" | "compact".
     */
    resolveMasterListEntry(list, value, options = {}) {
        const self = this;
        options = options || {};

        const listKey = typeof list === "string" ? list : (options.listKey || null);
        const entries = self.getMasterListEntries(list);
        const normalised = self.normaliseMasterListValue(value);
        const code = self.normaliseMasterListValue(options.code);

        let match = null;

        if (code) {
            match = self._matchMasterListByCode(entries, code);
        }

        if (!match && normalised) {
            match = self._matchMasterListByName(entries, normalised);
        }

        if (!match && normalised && listKey === "nationalities") {
            const countryMatch = self._matchMasterListByName(self.getMasterListEntries("countries"), normalised);
            if (countryMatch) {
                const entry = entries.find(e => String(e.id) === String(countryMatch.id));
                if (entry) {
                    match = { id: entry.id, name: entry.name, matched_on: countryMatch.matched_on, row: entry.row };
                }
            }
        }

        if (match) {
            return Object.assign({ list: listKey, input: value }, match);
        }

        if (options.log !== false && (normalised || code)) {
            console.warn(
                "WEB-4518: master list value not matched — add it as an alias in the server config if it is a known spelling",
                Object.assign({ list: listKey, value: value, code: options.code || null }, options.context || {})
            );
        }

        return null;
    }

    /**
     * WEB-4518 Pass 0 of resolveMasterListEntry(): exact ISO code.
     *
     * @private
     * @param {Array} entries getMasterListEntries() output.
     * @param {string} code Normalised ISO code.
     * @returns {{id: *, name: string, matched_on: string, row: Object}|null}
     */
    _matchMasterListByCode(entries, code) {
        const self = this;

        const entry = entries.find(e => e.code && self.normaliseMasterListValue(e.code) === code);

        return entry ? { id: entry.id, name: entry.name, matched_on: "code", row: entry.row } : null;
    }

    /**
     * WEB-4518 Passes 1–3 of resolveMasterListEntry(): main name(s), aliases, then the compact
     * form of both. Each pass runs over the whole list before the next, so an exact main-name
     * hit always beats an alias hit on another row.
     *
     * @private
     * @param {Array} entries getMasterListEntries() output.
     * @param {string} normalised normaliseMasterListValue() output.
     * @returns {{id: *, name: string, matched_on: string, row: Object}|null}
     */
    _matchMasterListByName(entries, normalised) {
        const self = this;
        const toResult = (entry, matchedOn) => ({ id: entry.id, name: entry.name, matched_on: matchedOn, row: entry.row });

        // (No for...of: the gulp rollup pipeline transpiles with Buble, which rejects it.)
        let entry = entries.find(e => e.names.some(n => self.normaliseMasterListValue(n) === normalised));
        if (entry) return toResult(entry, "name");

        entry = entries.find(e => e.aliases.some(a => self.normaliseMasterListValue(a) === normalised));
        if (entry) return toResult(entry, "alias");

        const compact = self.compactMasterListValue(normalised);
        if (compact === "") return null;

        entry = entries.find(e => e.names.concat(e.aliases).some(n => self.compactMasterListValue(n) === compact));

        return entry ? toResult(entry, "compact") : null;
    }

    /**
     * WEB-4518 Country name / ISO code -> the numeric `country_code` the Web binds in every
     * country dropdown (`option.country_code as option.name`). "VIETNAM" / "VN" -> 704 (Viet Nam).
     *
     * @param {*} value Country name as spelt by the third party (may be empty when `code` is given).
     * @param {string|null} [code] ISO 3166-1 alpha-2 code, tried first.
     * @param {Object|null} [context] Extra fields for the unmatched log line (source, field).
     * @returns {number|null} null when nothing matched — callers leave the field blank.
     */
    resolveCountryCode(value, code = null, context = null) {
        const self = this;

        const match = self.resolveMasterListEntry("countries", value, { code: code, context: context });

        return match ? match.id : null;
    }

    /**
     * WEB-4518 Nationality / ISO code -> the numeric nationality id (= country code) the Web
     * binds in nationality dropdowns. "SINGAPORE CITIZEN" / "SG" -> 702 (Singaporean); a plain
     * country name ("MYANMAR") also resolves, via the countries list.
     *
     * @param {*} value Nationality as spelt by the third party.
     * @param {string|null} [code] ISO 3166-1 alpha-2 code, tried first.
     * @param {Object|null} [context] Extra fields for the unmatched log line.
     * @param {string|Array} [list="nationalities"] The nationality rows to match against — pass
     *        the page's own list (SSEoiService.nationalities) when the page filters it, so a
     *        filtered-out nationality stays blank exactly as a manual pick would.
     * @returns {number|null}
     */
    resolveNationalityId(value, code = null, context = null, list = "nationalities") {
        const self = this;

        const match = self.resolveMasterListEntry(list, value, { code: code, context: context, listKey: "nationalities" });

        return match ? match.id : null;
    }

    /**
     * WEB-4518 Race spelling -> the master-list race NAME the Web binds and saves
     * (`option.name as option.name`): "chinese" / "CHINESE" -> "Chinese".
     *
     * The catch-all "Other" row is deliberately NOT resolved through an alias: on the Web the
     * value "Other" also requires the free-text other-race field, and every caller already
     * handles "no match" by selecting Other and keeping the incoming text there (a stored
     * "OTHERS" -> Other + "OTHERS", exactly as before). An exact "Other" still resolves to itself.
     *
     * @param {*} value The incoming race.
     * @param {string|Array} [list="races"] "races", "races_ec" or the page's rows (SSEoiService.races).
     * @param {{log?: boolean, context?: Object}} [options] log=false where free text is expected.
     * @returns {string|null} The main name, or null when the caller should fall back to Other.
     */
    resolveRaceName(value, list = "races", options = {}) {
        const self = this;

        const match = self.resolveMasterListEntry(list, value, Object.assign({ listKey: "races" }, options || {}));
        if (!match) return null;
        if (match.matched_on !== "name" && self.isOtherMasterListEntry(match)) return null;

        return match.name;
    }

    /**
     * WEB-4518 SingPass MyInfo race ({code, desc}) -> the Web's race dropdown value.
     *
     * MyInfo's own code map (CN / MY / IN / EU) is tried first, then the description against
     * the list's main names + aliases. Only a master-list name is ever bound:
     *  - matched a real race ("CHINESE", code CN)   -> { race: "Chinese", race_other: undefined }
     *  - matched the Other row ("OTHERS")           -> { race: "Other",   race_other: "" } (user specifies)
     *  - no match at all ("CAUCASIAN"), logged      -> { race: "Other",   race_other: "CAUCASIAN" }
     *
     * @param {{code?: string, desc?: string}|null} myInfoRace The MyInfo `race` object.
     * @param {string|Array} [list="races"] The page's race rows (EC projects use races_ec).
     * @param {Object|null} [context] Extra fields for the unmatched log line.
     * @returns {{race: string, race_other: (string|undefined)}} race_other is undefined when the
     *          caller should leave the free-text field untouched.
     */
    mapMyInfoRace(myInfoRace, list = "races", context = null) {
        const self = this;
        myInfoRace = myInfoRace || {};

        const byCode = { CN: "Chinese", MY: "Malay", IN: "Indian", EU: "Eurasian" }[String(myInfoRace.code || "").toUpperCase()];
        const desc = myInfoRace.desc;

        let match = byCode ? self.resolveMasterListEntry(list, byCode, { listKey: "races", log: false }) : null;
        if (!match && desc) {
            match = self.resolveMasterListEntry(list, desc, { listKey: "races", context: context });
        }

        if (match && !self.isOtherMasterListEntry(match)) {
            return { race: match.name, race_other: undefined };
        }

        return { race: "Other", race_other: match ? "" : (desc || byCode || "") };
    }

    getMaritalStatuses(ec_filtered = false) {
        const self = this;
        if (ec_filtered) return self.serverConfig.marital_statuses_ec;
        return self.serverConfig.marital_statuses;
    }

    getMaritalStatusName(id, ec_filtered = false) {
        const self = this;

        return self.searchArray(self.getMaritalStatuses(ec_filtered), id);
    }

    getHouseholdTypes() {
        const self = this;
        return self.serverConfig.household_types;
    }

    getHouseholdTypeName(code) {
        const self = this;

        return self.searchArray(self.getHouseholdTypes(), code);
    }

    getAbortReasons() {
        const self = this;

        return self.serverConfig.abort_reasons;
    }

    getBouncedReasons() {
        const self = this;

        return self.serverConfig.bounced_reasons;
    }

    getAbortReasonName(code) {
        const self = this;

        let name = self.searchArray(self.getAbortReasons(), code);

        if (!name) {
            name = self.getReissueReasonName(code);
        }

        return name;
    }

    getPaymentClauseName(code) {
        const self = this;

        let clauseName = self.searchArray(
            self.serverConfig.payment_types,
            code
        );

        if (typeof clauseName == "string") {
            return clauseName;
        } else {
            return "--";
        }
    }

    getPaymentClauses() {
        const self = this;

        return self.serverConfig.payment_types;
    }

    getReissueReasons() {
        const self = this;

        return self.serverConfig.reissue_reasons;
    }

    getReissueReasonName(code) {
        const self = this;

        return self.searchArray(self.getReissueReasons(), code);
    }

    getReissueTypes() {
        const self = this;

        return self.serverConfig.reissue_types;
    }

    getReissueTypeName(code) {
        const self = this;

        return self.searchArray(self.getReissueTypes(), code);
    }

    getPurchaseModes() {
        const self = this;

        return self.serverConfig.purchase_modes;
    }

    getPurchaseModeName(code) {
        const self = this;

        return self.searchArray(self.getPurchaseModes(), code);
    }

    getSaleTypes() {
        const self = this;

        return self.serverConfig.sales_types;
    }

    getSaleTypeName(code) {
        const self = this;

        return self.searchArray(self.getSaleTypes(), code);
    }

    //-------------------------------------------

    getReferralTypes() {
        const self = this;

        return self.serverConfig.referral_types;
    }

    getReferralTypeName(code) {
        const self = this;

        return self.searchArray(self.getReferralTypes(), code);
    }

    getReferralCodeLabel(referralType) {
        const self = this;

        if (referralType == 10) {
            // const REFERRAL_TYPE_STAFF = 10;
            return 'Staff ID';
        } else if (referralType == 11) {
            // const REFERRAL_TYPE_BUYER = 11;
            return 'NRIC / Passport No.';
        } else if (referralType == 99) {
            // const REFERRAL_TYPE_OTHER = 99;
            return 'Vendor Code';
        } else {
            // Default
            return 'Code';
        }
    }

    //-------------------------------------------

    getResidenceTypes(countryCode) {
        const self = this;

        let residenceTypes = self.serverConfig.residence_types;
        if(!countryCode) countryCode = self.SINGAPORE_COUNTRY_CODE; // Default is singapore
        
        if(countryCode){
            let types = [];

            residenceTypes.forEach( type => {
                if(type.country.indexOf(countryCode) != -1){
                    types.push(type);
                }
            });

            residenceTypes = types;
        }

        return residenceTypes;
    }

    getResidenceTypeName(code) {
        const self = this;

        return self.searchArray(self.getResidenceTypes(), code);
    }

    getSalutations() {
        const self = this;

        return self.serverConfig.salutations;
    }

    getSalutationName(code) {
        const self = this;

        if (!code) return null;

        if (isNaN(parseInt(code))) return code;

        return self.searchArray(self.getSalutations(), code);
    }

    // ------------------------------------------

    getDiscountTypes() {
        const self = this;

        return self.serverConfig.discount_types;
    }

    getDiscountTypeCode(type) {
        const self = this;

        let o = self.searchArrayE(self.getDiscountTypes(), type);

        return o ? o.code : "";
    }

    getDiscountTypeName(type) {
        const self = this;

        return self.searchArray(self.getDiscountTypes(), type);
    }
    // ------------------------------------------

    getLawFirms() {
        const self = this;
        return self.serverConfig.lawyers;
    }

    getCommissionTypes() {
        const self = this;

        return self.serverConfig.commission_types;
    }

    getCommissionTypeName(type) {
        const self = this;

        return self.searchArray(self.getCommissionTypes(), type);
    }

    getPaymentPlanClauseRuleStartFromTypes() {
        const self = this;

        return self.serverConfig.payment_plan_clause_rule_start_from_types;
    }

    getPaymentPlanClauseRuleTypeName(type) {
        const self = this;

        return self.searchArray(
            self.getPaymentPlanClauseRuleStartFromTypes(),
            type
        );
    }

    getAmlRiskAssessmentRemarksMaxLength() {
        const self = this;

        return self.serverConfig.AML_RISK_ASSESSMENT_REMARKS_MAX_LENGTH || 4000;
    }

    getIdentityTypes(countryCode){
        const self = this;

        if(!countryCode) countryCode = self.SINGAPORE_COUNTRY_CODE; // Default is singapore

        let identityTypes = self.serverConfig.identity_types;

        if(countryCode){
            identityTypes = identityTypes[countryCode];
        }

        return identityTypes;
    }

    getCountryDistricts(countryCode){
        const self = this;

        let districts = [];

        let country = self.getCountry(countryCode);
        if(country){
            districts = country.regions;
        }

        return districts;
    }

    getPPFormRequiredFields() {
        let fields = {
            // individual fields
            email: {label: "Email", required: true, mandatory: true, visible: true},
            phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            title: {label: "Salutation", required: false, visible: true},
            first_name: {label: "First Name", required: true, visible: true},
            last_name: {label: "Last Name", required: true, visible: true},
            legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            nationality: {label: "Nationality", required: true, visible: true},
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: {label: "Industry", required: true, visible: true},
            occupation: {label: "Occupation", required: true, visible: true},
            employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            gender: {label: "Gender", required: true, visible: true},
            dob: {label: "Date of Birth", required: true, visible: true},
            marital_status: {label: "Marital Status", required: false, visible: true},
            monthly_income: {label: "Monthly Income", required: false, visible: true},
            employment_status: {label: "Employment Status", required: false, visible: true},
            education_level: {label: "Education Level", required: false, visible: true},
            spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            phon2: {label: "Secondary Contact Number", required: false, visible: true},
            residence_type: {label: "Residence Type", required: false, visible: true},
            relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // company fields
            company_name: {label: "Company Name", required: true, mandatory: true, visible: true},
            company_registration_no: {
                label: "Company Registration No.",
                required: true,
                mandatory: true,
                visible: true
            },
            company_email: {label: "Company Email", required: true, mandatory: true, visible: true},
            company_phone1: {label: "Company Mobile No.", required: true, mandatory: true, visible: true},
            company_phone2: {label: "Company Contact No.", required: false, visible: true},
            company_country_of_origin: {
                label: "Company Country Of Origin",
                required: false,
                visible: true
            },

            //signatory fields
            signatory_email: {label: "Email", required: true, mandatory: true, visible: true},
            signatory_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            signatory_designation: {label: "Designation", required: true, visible: true},
            signatory_title: {label: "Salutation", required: false, visible: true},
            signatory_first_name: {label: "First Name", required: true, visible: true},
            signatory_last_name: {label: "Last Name", required: true, visible: true},
            signatory_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            signatory_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            signatory_nationality: {label: "Nationality", required: true, visible: true},
            signatory_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            signatory_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            signatory_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            signatory_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            signatory_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            signatory_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            signatory_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            signatory_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            signatory_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            signatory_industry: {label: "Industry", required: true, visible: true},
            signatory_occupation: {label: "Occupation", required: true, visible: true},
            signatory_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            signatory_gender: {label: "Gender", required: true, visible: true},
            signatory_dob: {label: "Date of Birth", required: true, visible: true},
            signatory_marital_status: {label: "Marital Status", required: false, visible: true},
            signatory_monthly_income: {label: "Monthly Income", required: false, visible: true},
            signatory_employment_status: {label: "Employment Status", required: false, visible: true},
            signatory_education_level: {label: "Education Level", required: false, visible: true},
            signatory_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            signatory_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            signatory_residence_type: {label: "Residence Type", required: false, visible: true},
            signatory_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Key Personnel fields
            key_personnel: {label: "Key Personnel", required: false, visible: false},
            key_personnel_email: {label: "Email", required: true, mandatory: true, visible: true},
            key_personnel_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            key_personnel_designation: {label: "Designation", required: false, visible: true},
            key_personnel_title: {label: "Salutation", required: false, visible: true},
            key_personnel_first_name: {label: "First Name", required: false, visible: true},
            key_personnel_last_name: {label: "Last Name", required: false, visible: true},
            key_personnel_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            key_personnel_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            key_personnel_nationality: {label: "Nationality", required: true, visible: true},
            key_personnel_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            key_personnel_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            key_personnel_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            key_personnel_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            key_personnel_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            key_personnel_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            key_personnel_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            key_personnel_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            key_personnel_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            key_personnel_industry: {label: "Industry", required: false, visible: true},
            key_personnel_occupation: {label: "Occupation", required: false, visible: true},
            key_personnel_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            key_personnel_gender: {label: "Gender", required: false, visible: true},
            key_personnel_dob: {label: "Date of Birth", required: false, visible: true},
            key_personnel_marital_status: {label: "Marital Status", required: false, visible: true},
            key_personnel_monthly_income: {label: "Monthly Income", required: false, visible: true},
            key_personnel_employment_status: {label: "Employment Status", required: false, visible: true},
            key_personnel_education_level: {label: "Education Level", required: false, visible: true},
            key_personnel_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            key_personnel_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            key_personnel_residence_type: {label: "Residence Type", required: false, visible: true},
            key_personnel_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Key Personnel fields
            key_personnel: {label: "Key Personnel", required: false, visible: false},
            key_personnel_email: {label: "Email", required: true, mandatory: true, visible: true},
            key_personnel_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            key_personnel_designation: {label: "Designation", required: false, visible: true},
            key_personnel_title: {label: "Salutation", required: false, visible: true},
            key_personnel_first_name: {label: "First Name", required: false, visible: true},
            key_personnel_last_name: {label: "Last Name", required: false, visible: true},
            key_personnel_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            key_personnel_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            key_personnel_nationality: {label: "Nationality", required: true, visible: true},
            key_personnel_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            key_personnel_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            key_personnel_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            key_personnel_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            key_personnel_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            key_personnel_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            key_personnel_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            key_personnel_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            key_personnel_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            key_personnel_industry: {label: "Industry", required: false, visible: true},
            key_personnel_occupation: {label: "Occupation", required: false, visible: true},
            key_personnel_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            key_personnel_gender: {label: "Gender", required: false, visible: true},
            key_personnel_dob: {label: "Date of Birth", required: false, visible: true},
            key_personnel_marital_status: {label: "Marital Status", required: false, visible: true},
            key_personnel_monthly_income: {label: "Monthly Income", required: false, visible: true},
            key_personnel_employment_status: {label: "Employment Status", required: false, visible: true},
            key_personnel_education_level: {label: "Education Level", required: false, visible: true},
            key_personnel_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            key_personnel_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            key_personnel_residence_type: {label: "Residence Type", required: false, visible: true},

            // address fields
            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: true
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: true
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            }
        }
        return fields;
    }

    getEOIFormRequiredFields() {
        let fields = {
            // individual fields
            email: { label: "Email", required: true, mandatory: true, visible: true },
            phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            title: { label: "Salutation", required: false, visible: true },
            first_name: { label: "First Name", required: true, visible: true },
            last_name: { label: "Last Name", required: true, visible: true },
            legal_name: { label: "Name as on IC/Passport", required: true, mandatory: true, visible: true },
            identity_type: { label: "Identity Type", required: true, mandatory: true, visible: true },
            nationality: { label: "Nationality", required: true, visible: true },
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: { label: "Country Of Origin/Birth", required: false, visible: true },
            passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by:{
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date:{
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date:{
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: { label: "Industry", required: true, visible: true },
            occupation: { label: "Occupation", required: true, visible: true },
            employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            gender: { label: "Gender", required: true, visible: true },
            dob: { label: "Date of Birth", required: true, visible: true },
            marital_status: { label: "Marital Status", required: false, visible: true },
            monthly_income: { label: "Monthly Income", required: false, visible: true},
            employment_status: { label: "Employment Status", required: false, visible: true},
            education_level: { label: "Education Level", required: false, visible: true},
            spouse_national_id: { label: "Spouse National ID", required: false, visible: true},
            phon2: { label: "Secondary Contact Number", required: false, visible: true },
            residence_type: { label: "Residence Type", required: false, visible: true },
            relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            //for company fields
            company_name: { label: "Company Name", required: true, mandatory: true, visible: true },
            company_registration_no: {
                label: "Company Registration No.",
                required: true,
                mandatory: true,
                visible: true
            },
            company_email: { label: "Company Email", required: true, mandatory: true, visible: true },
            company_phone1: { label: "Company Mobile No.", required: true, mandatory: true, visible: true },
            company_phone2: { label: "Company Contact No.", required: false, visible: true },
            company_country_of_origin: {
                label: "Company Country Of Origin",
                required: false,
                visible: true
            },

            // signatory fields
            signatory_email: { label: "Email", required: true, mandatory: true, visible: true },
            signatory_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            signatory_designation: {label: "Designation", required: true, visible: true},
            signatory_title: { label: "Salutation", required: false, visible: true },
            signatory_first_name: { label: "First Name", required: true, visible: true },
            signatory_last_name: { label: "Last Name", required: true, visible: true },
            signatory_legal_name: { label: "Name as on IC/Passport", required: true, mandatory: true, visible: true },
            signatory_identity_type: { label: "Identity Type", required: true, mandatory: true, visible: true },
            signatory_nationality: { label: "Nationality", required: true, visible: true },
            signatory_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            signatory_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            signatory_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            signatory_country_of_origin: { label: "Country Of Origin/Birth", required: false, visible: true },
            signatory_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            signatory_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            signatory_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            signatory_passport_issued_by:{
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_issued_date:{
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_expiry_date:{
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            signatory_industry: { label: "Industry", required: true, visible: true },
            signatory_occupation: { label: "Occupation", required: true, visible: true },
            signatory_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            signatory_gender: { label: "Gender", required: true, visible: true },
            signatory_dob: { label: "Date of Birth", required: true, visible: true },
            signatory_marital_status: { label: "Marital Status", required: false, visible: true },
            signatory_monthly_income: { label: "Monthly Income", required: false, visible: true},
            signatory_employment_status: { label: "Employment Status", required: false, visible: true},
            signatory_education_level: { label: "Education Level", required: false, visible: true},
            signatory_spouse_national_id: { label: "Spouse National ID", required: false, visible: true},
            signatory_phon2: { label: "Secondary Contact Number", required: false, visible: true },
            signatory_residence_type: { label: "Residence Type", required: false, visible: true },
            signatory_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Key Personnel fields
            key_personnel: {label: "Key Personnel", required: false, visible: false},
            key_personnel_email: {label: "Email", required: true, mandatory: true, visible: true},
            key_personnel_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            key_personnel_designation: {label: "Designation", required: false, visible: true},
            key_personnel_title: {label: "Salutation", required: false, visible: true},
            key_personnel_first_name: {label: "First Name", required: false, visible: true},
            key_personnel_last_name: {label: "Last Name", required: false, visible: true},
            key_personnel_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            key_personnel_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            key_personnel_nationality: {label: "Nationality", required: true, visible: true},
            key_personnel_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            key_personnel_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            key_personnel_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            key_personnel_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            key_personnel_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            key_personnel_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            key_personnel_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            key_personnel_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            key_personnel_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            key_personnel_industry: {label: "Industry", required: false, visible: true},
            key_personnel_occupation: {label: "Occupation", required: false, visible: true},
            key_personnel_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            key_personnel_gender: {label: "Gender", required: false, visible: true},
            key_personnel_dob: {label: "Date of Birth", required: false, visible: true},
            key_personnel_marital_status: {label: "Marital Status", required: false, visible: true},
            key_personnel_monthly_income: {label: "Monthly Income", required: false, visible: true},
            key_personnel_employment_status: {label: "Employment Status", required: false, visible: true},
            key_personnel_education_level: {label: "Education Level", required: false, visible: true},
            key_personnel_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            key_personnel_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            key_personnel_residence_type: {label: "Residence Type", required: false, visible: true},
            key_personnel_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Key Personnel fields
            key_personnel: {label: "Key Personnel", required: false, visible: false},
            key_personnel_email: {label: "Email", required: true, mandatory: true, visible: true},
            key_personnel_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            key_personnel_designation: {label: "Designation", required: false, visible: true},
            key_personnel_title: {label: "Salutation", required: false, visible: true},
            key_personnel_first_name: {label: "First Name", required: false, visible: true},
            key_personnel_last_name: {label: "Last Name", required: false, visible: true},
            key_personnel_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            key_personnel_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            key_personnel_nationality: {label: "Nationality", required: true, visible: true},
            key_personnel_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            key_personnel_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            key_personnel_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            key_personnel_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            key_personnel_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            key_personnel_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            key_personnel_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            key_personnel_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            key_personnel_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            key_personnel_industry: {label: "Industry", required: false, visible: true},
            key_personnel_occupation: {label: "Occupation", required: false, visible: true},
            key_personnel_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            key_personnel_gender: {label: "Gender", required: false, visible: true},
            key_personnel_dob: {label: "Date of Birth", required: false, visible: true},
            key_personnel_marital_status: {label: "Marital Status", required: false, visible: true},
            key_personnel_monthly_income: {label: "Monthly Income", required: false, visible: true},
            key_personnel_employment_status: {label: "Employment Status", required: false, visible: true},
            key_personnel_education_level: {label: "Education Level", required: false, visible: true},
            key_personnel_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            key_personnel_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            key_personnel_residence_type: {label: "Residence Type", required: false, visible: true},

            // address fields
            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: true
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: true
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            },
        };
        return fields;
    }

    getWitnessFormRequiredFields(){
        let fields = {
            email: { label: "Email", required: true, mandatory: true, visible: true },
            phone1: {label: "Primary Contact Number", required: true, mandatory: true, visible: true },
            title: { label: "Salutation", required: false, visible: false },
            first_name: { label: "First Name", required: false, visible: false },
            last_name: { label: "Last Name", required: false, visible: false },
            legal_name: { label: "Name as on IC/Passport", required: true, mandatory: true, visible: true },
            identity_type: { label: "Identity Type", required: true, mandatory: true, visible: true },
            company_name: { label: "Company Name", required: false, visible: false },
            company_registration_no: {
                label: "Company Registration No.",
                required: false,
                visible: false
            },
            company_email: { label: "Company Email", required: false, visible: false },
            company_phone1: { label: "Company Mobile No.", required: false, visible: false },
            company_phone2: { label: "Company Contact No.", required: false, visible: false },
            company_country_of_origin: {
                label: "Company Country Of Origin",
                required: false,
                visible: false
            },
            nationality: { label: "Nationality", required: false, visible: false },
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: { label: "Country Of Origin/Birth", required: false, visible: false },
            passport_no: {
                label: "Passport No.",
                required: false,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: false,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: false,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by:{
                label: "Passport Issued By",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date:{
                label: "Passport Issued Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date:{
                label: "Passport Expiry Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            race: {
                label: "Race",
                required: false,
                visible: false,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: { label: "Industry", required: false, visible: false},
            occupation: { label: "Occupation", required: false, visible: false},
            employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            gender: { label: "Gender", required: false, visible: false, mandatory: false },
            dob: { label: "Date of Birth", required: false, visible: false },
            marital_status: { label: "Marital Status", required: false, visible: false, mandatory: false },
            monthly_income: { label: "Monthly Income", required: false, visible: false, mandatory: false},
            employment_status: { label: "Employment Status", required: false, visible: false, mandatory: false},
            education_level: { label: "Education Level", required: false, visible: false, mandatory: false},
            spouse_national_id: { label: "Spouse National ID", required: false, visible: false, mandatory: false},
            phon2: { label: "Secondary Contact Number", required: false, visible: false },
            relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: true, visible: true, mandatory: false},
            residence_type: { label: "Residence Type", required: false, visible: false, mandatory: false },
            primary_address_line1: {
                label: "Primary Address House/Block",
                required: false, visible: false
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: false
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: false
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: false
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: false
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: false, mandatory: false
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: false, mandatory: false
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: false, visible: false
            }
        };

        return fields;
    }

    getWitnessSettings(){
        let fields = {
            enable: 1,
        };

        return fields;
    }

    getSaleOTPRepresentativeSettings() {
        return {
            enable: 1,
        };
    }

    getNonBuyerPayeeFormRequiredFields() {
        let fields = {
            email: { label: "Email", required: true, mandatory: true, visible: true },
            phone1: {label: "Primary Contact Number", required: true, mandatory: true, visible: true },
            title: { label: "Salutation", required: true, visible: true },
            first_name: { label: "First Name", required: true, visible: true },
            last_name: { label: "Last Name", required: true, visible: true },
            legal_name: { label: "Name as on IC/Passport", required: true, mandatory: true, visible: true },
            identity_type: { label: "Identity Type", required: true, mandatory: true, visible: true },
            // company_name: { label: "Company Name", required: true, mandatory: true, visible: true },
            // company_registration_no: {
            //     label: "Company Registration No.",
            //     required: true,
            //     mandatory: true,
            //     visible: true
            // },
            // company_email: { label: "Company Email", required: true, mandatory: true, visible: true },
            // company_phone1: { label: "Company Mobile No.", required: true, mandatory: true, visible: true },
            // company_phone2: { label: "Company Contact No.", required: false, visible: true },
            // company_country_of_origin: {
            //     label: "Company Country Of Origin",
            //     required: false,
            //     visible: true
            // },
            nationality: { label: "Nationality", required: true, visible: true, mandatory: true },
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: { label: "Country Of Origin/Birth", required: true, visible: true },
            passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by:{
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date:{
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date:{
                label: "Passport Expiry Date",
                required: true,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            race: {
                label: "Race",
                required: false,
                visible: false,
                mandatory: true,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: { label: "Industry", required: true, visible: true},
            occupation: { label: "Occupation", required: true, visible: true},
            employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            gender: { label: "Gender", required: true, visible: true, mandatory: false },
            dob: { label: "Date of Birth", required: true, visible: true },
            marital_status: { label: "Marital Status", required: false, visible: false, mandatory: true },
            monthly_income: { label: "Monthly Income", required: false, visible: false, mandatory: true},
            employment_status: { label: "Employment Status", required: false, visible: false, mandatory: true},
            education_level: { label: "Education Level", required: false, visible: false, mandatory: true},
            spouse_national_id: { label: "Spouse National ID", required: false, visible: false, mandatory: true},
            phon2: { label: "Secondary Contact Number", required: false, visible: true },
            residence_type: { label: "Residence Type", required: false, visible: false, mandatory: true },
            relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: true, visible: true, mandatory: true},

            // Company Fields
            company_name: {label: "Company Name", required: true, mandatory: true, visible: true},
            company_registration_no: {
                label: "Company Registration No.",
                required: true,
                mandatory: true,
                visible: true
            },
            company_email: {label: "Company Email", required: true, mandatory: true, visible: true},
            company_phone1: {label: "Company Mobile No.", required: true, mandatory: true, visible: true},
            company_phone2: {label: "Company Contact No.", required: false, visible: true},
            company_country_of_origin: {
                label: "Company Country Of Origin",
                required: false,
                visible: true
            },

            //signatory fields
            signatory_email: {label: "Email", required: true, mandatory: true, visible: true},
            signatory_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            signatory_designation: {label: "Designation", required: true, visible: true},
            signatory_title: {label: "Salutation", required: false, visible: true},
            signatory_first_name: {label: "First Name", required: true, visible: true},
            signatory_last_name: {label: "Last Name", required: true, visible: true},
            signatory_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            signatory_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            signatory_nationality: {label: "Nationality", required: true, visible: true},
            signatory_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            signatory_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            signatory_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            signatory_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            signatory_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            signatory_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            signatory_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            signatory_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            signatory_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            signatory_industry: {label: "Industry", required: true, visible: true},
            signatory_occupation: {label: "Occupation", required: true, visible: true},
            signatory_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            signatory_gender: {label: "Gender", required: true, visible: true},
            signatory_dob: {label: "Date of Birth", required: true, visible: true},
            signatory_marital_status: {label: "Marital Status", required: false, visible: true},
            signatory_monthly_income: {label: "Monthly Income", required: false, visible: true},
            signatory_employment_status: {label: "Employment Status", required: false, visible: true},
            signatory_education_level: {label: "Education Level", required: false, visible: true},
            signatory_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            signatory_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            signatory_residence_type: {label: "Residence Type", required: false, visible: true},
            signatory_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Key Personnel fields
            key_personnel: {label: "Key Personnel", required: false, visible: false},
            key_personnel_email: {label: "Email", required: true, mandatory: true, visible: true},
            key_personnel_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            key_personnel_designation: {label: "Designation", required: false, visible: true},
            key_personnel_title: {label: "Salutation", required: false, visible: true},
            key_personnel_first_name: {label: "First Name", required: false, visible: true},
            key_personnel_last_name: {label: "Last Name", required: false, visible: true},
            key_personnel_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            key_personnel_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            key_personnel_nationality: {label: "Nationality", required: true, visible: true},
            key_personnel_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            key_personnel_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            key_personnel_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            key_personnel_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            key_personnel_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            key_personnel_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            key_personnel_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            key_personnel_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            key_personnel_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            key_personnel_industry: {label: "Industry", required: false, visible: true},
            key_personnel_occupation: {label: "Occupation", required: false, visible: true},
            key_personnel_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            key_personnel_gender: {label: "Gender", required: false, visible: true},
            key_personnel_dob: {label: "Date of Birth", required: false, visible: true},
            key_personnel_marital_status: {label: "Marital Status", required: false, visible: true},
            key_personnel_monthly_income: {label: "Monthly Income", required: false, visible: true},
            key_personnel_employment_status: {label: "Employment Status", required: false, visible: true},
            key_personnel_education_level: {label: "Education Level", required: false, visible: true},
            key_personnel_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            key_personnel_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            key_personnel_residence_type: {label: "Residence Type", required: false, visible: true},
            key_personnel_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: false, mandatory: true
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: false, mandatory: true
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            }
        };
        return fields;
    }

    getNonBuyerPayeeSettings(){
        let fields = {
            enable: 1,
        };
        return fields;
    }

    getTimeZones(){
        const self = this;

        let timeZones = []; 

        try{

            let momentZones = moment.tz.names();
            
            momentZones.forEach((timeZone) => {
              let gmt = moment().tz(timeZone).format('Z');
              let abbr = moment().tz(timeZone).zoneAbbr();

              if($.isNumeric(abbr)) abbr = "";

              if(!abbr && timeZone.includes('Singapore')) abbr = "SGT";
              
              timeZones.push({
                id: timeZone, 
                label: abbr, 
                name: `${timeZone}${abbr? ' - '+abbr : ''} (${gmt})`, 
                time: gmt
              });
            });

        }
        catch(ex){
            console.log(ex);
        }

        return timeZones;
    }

    getDefaultToggleSettings(is_enabled){
        let fields = null;
        if(is_enabled){
            fields = {
                enabled: 0,
            };
        }else {
            fields = {
                enable: 0,
            };
        }

        return fields;
    }

    getPowerOfAttorneySettings(){
        return {
            enable: 1,
        };
    }

    getPowerOfAttorneyRequiredFields() {
        return {
            email: {label: "Email", required: true, mandatory: true, visible: true},
            phone1: {label: "Primary Contact Number", required: true, mandatory: true, visible: true},
            title: {label: "Salutation", required: false, visible: false},
            first_name: {label: "First Name", required: false, visible: false},
            last_name: {label: "Last Name", required: false, visible: false},
            legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            // company_name: {label: "Company Name", required: true, mandatory: true, visible: true},
            // company_registration_no: {
            //     label: "Company Registration No.",
            //     required: true,
            //     mandatory: true,
            //     visible: true
            // },
            // company_email: {label: "Company Email", required: true, mandatory: true, visible: true},
            // company_phone1: {label: "Company Mobile No.", required: true, mandatory: true, visible: true},
            // company_phone2: {label: "Company Contact No.", required: false, visible: true},
            // company_country_of_origin: {
            //     label: "Company Country Of Origin",
            //     required: false,
            //     visible: true
            // },
            nationality: {label: "Nationality", required: true, visible: true, mandatory: true},
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: {label: "Country Of Origin/Birth", required: true, visible: true},
            passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: false,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date: {
                label: "Passport Expiry Date",
                required: true,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            race: {
                label: "Race",
                required: false,
                visible: false,
                mandatory: false,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: {label: "Industry", required: true, visible: true},
            occupation: {label: "Occupation", required: true, visible: true},
            employer_name: {label: "Employer Name", required: false, visible: true, mandatory: false},
            gender: {label: "Gender", required: false, visible: false, mandatory: false},
            dob: {label: "Date of Birth", required: true, visible: true},
            marital_status: {label: "Marital Status", required: false, visible: false, mandatory: false},
            monthly_income: {label: "Monthly Income", required: false, visible: false, mandatory: false},
            employment_status: {label: "Employment Status", required: false, visible: false, mandatory: false},
            education_level: {label: "Education Level", required: false, visible: false, mandatory: false},
            spouse_national_id: {label: "Spouse National ID", required: false, visible: false, mandatory: false},
            phon2: {label: "Secondary Contact Number", required: false, visible: false},
            relationship_with_buyer_1: {
                label: "Relationship with Buyer 1",
                required: false,
                visible: false,
                mandatory: false
            },
            residence_type: {label: "Residence Type", required: false, visible: false, mandatory: false},
            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: false, mandatory: false
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: true, mandatory: true
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            }
        };
    }

    getOtherBeneficiaryOwnerSettings(){
        return {
            enable: 1,
        };
    }

    getOtherBeneficiaryOwnerRequiredFields() {
        return {
            email: {label: "Email", required: true, mandatory: true, visible: true},
            phone1: {label: "Primary Contact Number", required: true, mandatory: true, visible: true},
            title: {label: "Salutation", required: false, visible: false},
            first_name: {label: "First Name", required: false, visible: false},
            last_name: {label: "Last Name", required: false, visible: false},
            legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            // company_name: {label: "Company Name", required: true, mandatory: true, visible: true},
            // company_registration_no: {
            //     label: "Company Registration No.",
            //     required: true,
            //     mandatory: true,
            //     visible: true
            // },
            // company_email: {label: "Company Email", required: true, mandatory: true, visible: true},
            // company_phone1: {label: "Company Mobile No.", required: true, mandatory: true, visible: true},
            // company_phone2: {label: "Company Contact No.", required: false, visible: true},
            // company_country_of_origin: {
            //     label: "Company Country Of Origin",
            //     required: false,
            //     visible: true
            // },
            nationality: {label: "Nationality", required: true, visible: true, mandatory: true},
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: {label: "Country Of Origin/Birth", required: true, visible: true},
            passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: false,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date: {
                label: "Passport Expiry Date",
                required: true,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            race: {
                label: "Race",
                required: false,
                visible: false,
                mandatory: false,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: {label: "Industry", required: true, visible: true},
            occupation: {label: "Occupation", required: true, visible: true},
            employer_name: {label: "Employer Name", required: false, visible: true, mandatory: false},
            gender: {label: "Gender", required: false, visible: false, mandatory: false},
            dob: {label: "Date of Birth", required: true, visible: true},
            marital_status: {label: "Marital Status", required: false, visible: false, mandatory: false},
            monthly_income: {label: "Monthly Income", required: false, visible: false, mandatory: false},
            employment_status: {label: "Employment Status", required: false, visible: false, mandatory: false},
            education_level: {label: "Education Level", required: false, visible: false, mandatory: false},
            spouse_national_id: {label: "Spouse National ID", required: false, visible: false, mandatory: false},
            phon2: {label: "Secondary Contact Number", required: false, visible: false},
            relationship_with_buyer_1: {
                label: "Relationship with Buyer 1",
                required: false,
                visible: false,
                mandatory: false
            },
            residence_type: {label: "Residence Type", required: false, visible: false, mandatory: false},
            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: false, mandatory: false
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: true, mandatory: true
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            }
        };
    }

    getTruePurchaserSettings(){
        return {
            enable: 1,
        };
    }

    getTruePurchaserRequiredFields() {
        return {
            email: {label: "Email", required: true, mandatory: true, visible: true},
            phone1: {label: "Primary Contact Number", required: true, mandatory: true, visible: true},
            title: {label: "Salutation", required: false, visible: false},
            first_name: {label: "First Name", required: false, visible: false},
            last_name: {label: "Last Name", required: false, visible: false},
            legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            nationality: {label: "Nationality", required: true, visible: true, mandatory: true},
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: {label: "Country Of Origin/Birth", required: true, visible: true},
            passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: false,
                comment: "Required if nationality Foreigner"
            },
            passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date: {
                label: "Passport Expiry Date",
                required: true,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            race: {
                label: "Race",
                required: false,
                visible: false,
                mandatory: false,
                comment: "Show/Hide on the basis of nationality"
            },
            industry: {label: "Industry", required: true, visible: true},
            occupation: {label: "Occupation", required: true, visible: true},
            employer_name: {label: "Employer Name", required: false, visible: true, mandatory: false},
            gender: {label: "Gender", required: false, visible: false, mandatory: false},
            dob: {label: "Date of Birth", required: true, visible: true},
            marital_status: {label: "Marital Status", required: false, visible: false, mandatory: false},
            monthly_income: {label: "Monthly Income", required: false, visible: false, mandatory: false},
            employment_status: {label: "Employment Status", required: false, visible: false, mandatory: false},
            education_level: {label: "Education Level", required: false, visible: false, mandatory: false},
            spouse_national_id: {label: "Spouse National ID", required: false, visible: false, mandatory: false},
            phon2: {label: "Secondary Contact Number", required: false, visible: false},
            residence_type: {label: "Residence Type", required: false, visible: false, mandatory: false},
            relationship_with_buyer_1: {
                label: "Relationship with Buyer 1",
                required: false,
                visible: false,
                mandatory: false
            },

            // Company Fields
            company_name: {label: "Company Name", required: true, mandatory: true, visible: true},
            company_registration_no: {
                label: "Company Registration No.",
                required: true,
                mandatory: true,
                visible: true
            },
            company_email: {label: "Company Email", required: true, mandatory: true, visible: true},
            company_phone1: {label: "Company Mobile No.", required: true, mandatory: true, visible: true},
            company_phone2: {label: "Company Contact No.", required: false, visible: true},
            company_country_of_origin: {
                label: "Company Country Of Origin",
                required: false,
                visible: true
            },

            //signatory fields
            signatory_email: {label: "Email", required: true, mandatory: true, visible: true},
            signatory_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            signatory_designation: {label: "Designation", required: false, visible: true},
            signatory_title: {label: "Salutation", required: false, visible: true},
            signatory_first_name: {label: "First Name", required: false, visible: true},
            signatory_last_name: {label: "Last Name", required: false, visible: true},
            signatory_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            signatory_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            signatory_nationality: {label: "Nationality", required: true, visible: true},
            signatory_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            signatory_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            signatory_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            signatory_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            signatory_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            signatory_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            signatory_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            signatory_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            signatory_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            signatory_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            signatory_industry: {label: "Industry", required: false, visible: true},
            signatory_occupation: {label: "Occupation", required: false, visible: true},
            signatory_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            signatory_gender: {label: "Gender", required: false, visible: true},
            signatory_dob: {label: "Date of Birth", required: false, visible: true},
            signatory_marital_status: {label: "Marital Status", required: false, visible: true},
            signatory_monthly_income: {label: "Monthly Income", required: false, visible: true},
            signatory_employment_status: {label: "Employment Status", required: false, visible: true},
            signatory_education_level: {label: "Education Level", required: false, visible: true},
            signatory_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            signatory_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            signatory_residence_type: {label: "Residence Type", required: false, visible: true},
            signatory_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Key Personnel fields
            key_personnel: {label: "Key Personnel", required: false, visible: false},
            key_personnel_email: {label: "Email", required: true, mandatory: true, visible: true},
            key_personnel_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            key_personnel_designation: {label: "Designation", required: false, visible: true},
            key_personnel_title: {label: "Salutation", required: false, visible: true},
            key_personnel_first_name: {label: "First Name", required: false, visible: true},
            key_personnel_last_name: {label: "Last Name", required: false, visible: true},
            key_personnel_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            key_personnel_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            key_personnel_nationality: {label: "Nationality", required: true, visible: true},
            key_personnel_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            key_personnel_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            key_personnel_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            key_personnel_country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            key_personnel_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            key_personnel_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            key_personnel_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: true,
                comment: "Required if nationality Foreigner"
            },
            key_personnel_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            key_personnel_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            key_personnel_race: {
                label: "Race",
                required: false,
                visible: true,
                comment: "Show/Hide on the basis of nationality"
            },
            key_personnel_industry: {label: "Industry", required: false, visible: true},
            key_personnel_occupation: {label: "Occupation", required: false, visible: true},
            key_personnel_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            key_personnel_gender: {label: "Gender", required: false, visible: true},
            key_personnel_dob: {label: "Date of Birth", required: false, visible: true},
            key_personnel_marital_status: {label: "Marital Status", required: false, visible: true},
            key_personnel_monthly_income: {label: "Monthly Income", required: false, visible: true},
            key_personnel_employment_status: {label: "Employment Status", required: false, visible: true},
            key_personnel_education_level: {label: "Education Level", required: false, visible: true},
            key_personnel_spouse_national_id: {label: "Spouse National ID", required: false, visible: true},
            key_personnel_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            key_personnel_residence_type: {label: "Residence Type", required: false, visible: true},
            key_personnel_relationship_with_buyer_1: { label: "Relationship with Buyer 1", required: false, visible: false, mandatory: false},

            // Legal Entity fields
            legal_entity_email: {label: "Email", required: true, mandatory: true, visible: true},
            legal_entity_phone1: {
                label: "Primary Contact Number",
                required: true,
                mandatory: true,
                visible: true
            },
            legal_entity_designation: {label: "Designation", required: false, visible: false},
            legal_entity_title: {label: "Salutation", required: false, visible: false},
            legal_entity_first_name: {label: "First Name", required: false, visible: false},
            legal_entity_last_name: {label: "Last Name", required: false, visible: false},
            legal_entity_legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            legal_entity_identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            legal_entity_nationality: {label: "Nationality", required: true, visible: true},
            legal_entity_date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            legal_entity_other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            legal_entity_previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            legal_entity_country_of_origin: {label: "Country Of Origin/Birth", required: true, visible: true},
            legal_entity_passport_no: {
                label: "Passport No.",
                required: true,
                visible: true,
                comment: "Required if nationality foreigner"
            },
            legal_entity_national_id: {
                label: "NRIC",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            legal_entity_foreigner_national_id: {
                label: "Foreigner National ID",
                required: false,
                visible: false,
                comment: "Required if nationality Foreigner"
            },
            legal_entity_passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            legal_entity_passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            legal_entity_passport_expiry_date: {
                label: "Passport Expiry Date",
                required: true,
                visible: true,
                comment: "show/hide on basis of nationality"
            },

            legal_entity_race: {
                label: "Race",
                required: false,
                visible: false,
                comment: "Show/Hide on the basis of nationality"
            },
            legal_entity_industry: {label: "Industry", required: true, visible: true},
            legal_entity_occupation: {label: "Occupation", required: true, visible: true},
            legal_entity_employer_name: {label: "Employer Name", required: false, visible: false, mandatory: false},
            legal_entity_gender: {label: "Gender", required: false, visible: false},
            legal_entity_dob: {label: "Date of Birth", required: true, visible: true},
            legal_entity_marital_status: {label: "Marital Status", required: false, visible: false},
            legal_entity_monthly_income: {label: "Monthly Income", required: false, visible: false},
            legal_entity_employment_status: {label: "Employment Status", required: false, visible: false},
            legal_entity_education_level: {label: "Education Level", required: false, visible: false},
            legal_entity_spouse_national_id: {label: "Spouse National ID", required: false, visible: false},
            legal_entity_phon2: {label: "Secondary Contact Number", required: false, visible: true},
            legal_entity_residence_type: {label: "Residence Type", required: false, visible: false},

            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: false, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            primary_address_province: {
                label: "Primary Address Province",
                required: false, visible: false, mandatory: false
            },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: true, mandatory: true
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            }
        };
    }

    getBeneficiaryOwnerRequiredFields() {
        return {
            email: {label: "Email", required: false, mandatory: false, visible: true},
            phone1: {label: "Primary Contact Number", required: false, mandatory: false, visible: true},
            title: {label: "Salutation", required: true, visible: true},
            // first_name: {label: "First Name", required: false, visible: false},
            // last_name: {label: "Last Name", required: false, visible: false},
            legal_name: {label: "Name as on IC/Passport", required: true, mandatory: true, visible: true},
            identity_type: {label: "Identity Type", required: true, mandatory: true, visible: true},
            // company_name: {label: "Company Name", required: true, mandatory: true, visible: true},
            // company_registration_no: {
            //     label: "Company Registration No.",
            //     required: true,
            //     mandatory: true,
            //     visible: true
            // },
            // company_email: {label: "Company Email", required: true, mandatory: true, visible: true},
            // company_phone1: {label: "Company Mobile No.", required: true, mandatory: true, visible: true},
            // company_phone2: {label: "Company Contact No.", required: false, visible: true},
            // company_country_of_origin: {
            //     label: "Company Country Of Origin",
            //     required: false,
            //     visible: true
            // },
            nationality: {label: "Nationality", required: true, visible: true, mandatory: true},
            date_of_naturalization: { label: "Date of Naturalization", required: false, visible: false },
            other_nationalities: { label: "Other Nationalities", required: false, visible: false },
            previous_nationalities: { label: "Previous Nationalities", required: false, visible: false },
            country_of_origin: {label: "Country Of Origin/Birth", required: false, visible: true},
            // passport_no: {
            //     label: "Passport No.",
            //     required: true,
            //     visible: true,
            //     comment: "Required if nationality foreigner"
            // },
            national_id: {
                label: "Identity Number",
                required: true,
                visible: true,
                comment: "Required if nationality SG/SG-PR"
            },
            // foreigner_national_id: {
            //     label: "Foreigner National ID",
            //     required: false,
            //     visible: false,
            //     comment: "Required if nationality Foreigner"
            // },
            passport_issued_by: {
                label: "Passport Issued By",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_issued_date: {
                label: "Passport Issued Date",
                required: false,
                visible: false,
                comment: "show/hide on basis of nationality"
            },
            passport_expiry_date: {
                label: "Passport Expiry Date",
                required: false,
                visible: true,
                comment: "show/hide on basis of nationality"
            },
            // race: {
            //     label: "Race",
            //     required: false,
            //     visible: false,
            //     mandatory: false,
            //     comment: "Show/Hide on the basis of nationality"
            // },
            industry: {label: "Industry", required: false, visible: true},
            occupation: {label: "Occupation", required: false, visible: true},
            // employer_name: {label: "Employer Name", required: false, visible: true, mandatory: false},
            gender: {label: "Gender", required: true, visible: true, mandatory: false},
            dob: {label: "Date of Birth", required: false, visible: true},
            // marital_status: {label: "Marital Status", required: false, visible: false, mandatory: false},
            // monthly_income: {label: "Monthly Income", required: false, visible: false, mandatory: false},
            // employment_status: {label: "Employment Status", required: false, visible: false, mandatory: false},
            // education_level: {label: "Education Level", required: false, visible: false, mandatory: false},
            // spouse_national_id: {label: "Spouse National ID", required: false, visible: false, mandatory: false},
            // phon2: {label: "Secondary Contact Number", required: false, visible: false},
            // relationship_with_buyer_1: {
            //     label: "Relationship with Buyer 1",
            //     required: false,
            //     visible: false,
            //     mandatory: false
            // },
            // residence_type: {label: "Residence Type", required: false, visible: false, mandatory: false},
            primary_address_line1: {
                label: "Primary Address House/Block",
                required: true, visible: true
            },
            primary_address_line2: {
                label: "Primary Address Street Name",
                required: true, visible: true
            },
            primary_address_unit_no: {
                label: "Primary Address Unit No.",
                required: false, visible: true
            },
            primary_address_postcode: {
                label: "Primary Address Postcode",
                required: false, visible: true
            },
            primary_address_city: {
                label: "Primary Address City",
                required: false, visible: true
            },
            // primary_address_province: {
            //     label: "Primary Address Province",
            //     required: false, visible: false, mandatory: false
            // },
            primary_address_district: {
                label: "Primary Address District",
                required: false, visible: true, mandatory: false
            },
            primary_address_country: {
                label: "Primary Address Country",
                required: true, visible: true
            }
        };
    }
}

SSConfigService.$inject = ["$localStorage"];
app.service("SSConfigService", SSConfigService);
